<template>
  <div class="container" style="padding-top: 5rem">
    <div class="account-box">
      <!-- LOGIN FORM -->
      <div class="account-wrapper" v-if="isUnauthorized">
        <h3 class="account-title">Unauthorized Access</h3>
      </div>
      <div class="account-wrapper" v-else>
        <h3 class="account-title">
          {{ merchantName }}<br />
          E-Coupon Management System<br />Merchant Login
        </h3>
        <hr />
        <form @submit.prevent="login">
          <div
            role="alert"
            class="alert alert-success"
            v-if="forgotPasswordSuccess || changePasswordSuccess"
          >
            <div class="row align-items-center">
              <div class="col-2">
                <i class="fa fa-check-circle fa-2x"></i>
              </div>
              <div class="col-10 pl-0" style="word-spacing: -3px">
                <template v-if="forgotPasswordSuccess">
                  If the email account exists, a link is sent to the email
                  address to reset your password
                </template>
                <template v-if="changePasswordSuccess">
                  Your password has been reset. Please login below with your new
                  password.
                </template>
              </div>
            </div>
          </div>
          <p class="text-danger text-center" v-if="errorMessage">
            {{ errorMessage }}
          </p>
          <div class="form-group">
            <label>Email</label>
            <input
              class="form-control"
              type="email"
              v-model="email"
              maxlength="100"
              autocomplete="username"
              required
            />
          </div>
          <div class="form-group">
            <label>Password</label>
            <input
              class="form-control"
              type="password"
              v-model="password"
              maxlength="50"
              autocomplete="current-password"
              required
            />
          </div>
          <div class="form-group text-center">
            <button class="btn btn-primary account-btn" type="submit">
              Login
            </button>
          </div>
          <div class="form-group text-center mb-1">
            <router-link
              :to="{
                name: 'merchantForgotPassword',
                params: { code: $route.params.code },
              }"
            >
              Forgot password?
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
    
  <script>
import API from "../../http-common.js";

export default {
  data() {
    return {
      errorMessage: "",
      email: "",
      password: "",
      isUnauthorized: false,
      merchantName: ""
    };
  },
  computed: {
    forgotPasswordSuccess() {
      return this.$store.state.forgotPasswordSuccess;
    },
    changePasswordSuccess() {
      return this.$store.state.changePasswordSuccess;
    },
  },
  methods: {
    login() {
      this.errorMessage = "";
      this.$store.state.forgotPasswordSuccess = false;
      this.$store.state.changePasswordSuccess = false;
      this.$store.state.isLoading = true;
      console.log("Call Login API");
      API.login({
        merchant_code: this.$route.params.code,
        email: this.email,
        password: this.password,
      })
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            localStorage.setItem(
              "emstoken",
              JSON.stringify(response.data.data)
            );

            console.log(response.data.data);

            let data = response.data.data;
            if ( data.allow_pin_redemption ) {
              this.$router.replace({ name: "merchantRedeem" });
            }
            else if ( data.allow_batch_ecoupon ) {
              this.$router.replace({ name: "merchantBatchEcouponList" });
            }
            else if ( data.allow_flexible_ecoupon ) {
              this.$router.replace({ name: "merchantFlexibleEcouponList" });
            }
            else {
              this.$router.replace({ name: "merchantMerchantUserList" });
            }
          } else {
            this.errorMessage = response.data.message;
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
          this.errorMessage = error;
        });
    },
    checkMerchantExists() {
      API.checkMerchantExists({ code: this.$route.params.code })
        .then((response) => {
          if (response.data.success) {
            this.isUnauthorized = !response.data.is_exists;
            this.merchantName = response.data.merchantName;
          } else {
            this.errorMessage = response.data.message;
          }

          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
          this.errorMessage = error;
        });
    },
  },
  created() {
    if (!this.$route.params.code) this.isUnauthorized = true;
    else this.checkMerchantExists();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Merchant/Login.vue